/* global axios */
import ApiClient from '../ApiClient';

class WhatsappTemplates extends ApiClient {
  constructor() {
    super('whatsapp/templates', { accountScoped: true });
  }

  getTemplates(inboxId) {
    return axios.get(this.url, { params: { inbox_id: inboxId } });
  }

  createTemplate({ inboxId, template }) {
    return axios.post(this.url, { inbox_id: inboxId, template });
  }

  deleteTemplate({ inboxId, name }) {
    return axios.delete(`${this.url}/${name}`, {
      params: { inbox_id: inboxId },
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/sync`, { inbox_id: inboxId });
  }
}

export default new WhatsappTemplates();
